/* eslint-disable react/prop-types */
import classes from "./status.module.scss";

import classNames from "classnames";
import Flex from "@/components-library/layout/flex";
import Label from "@/components-library/widgets/label";
import Grid from "@/components-library/layout/grid";
import DatePicker, { registerLocale } from "react-datepicker";
import it from "date-fns/locale/it";
function Status({
  openingDate,
  reportingDate,
  closingDate,
  onOpeningDateChange,
  onReportingDateChange,
  onClosingDateChange,
  isOpeningDateValid,
  isReportingDateValid,
  isClosingDateValid,
}) {
  registerLocale("it", it);
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="center"
      className={classes.infoContainer}
    >
      <Label
        tag="h6"
        weight="bold"
        color="secondary"
        align="start"
        className={classes.subTitle}
      >
        Stato bando
      </Label>

      <Grid columns="1fr 1fr 1fr">
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.dateArea, {
            [classes.valid]: isOpeningDateValid,
          })}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Data apertura
          </Label>
          <DatePicker
            locale="it"
            selected={openingDate}
            onChange={(date) => onOpeningDateChange(date)}
            wrapperClassName="datePicker"
            dateFormat={"dd/MM/yyyy"}
          />
        </Flex>
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.dateArea, {
            [classes.valid]: isReportingDateValid,
          })}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Chiusura sportello
          </Label>
          <DatePicker
            locale="it"
            selected={reportingDate}
            onChange={(date) => onReportingDateChange(date)}
            wrapperClassName="datePicker"
            dateFormat={"dd/MM/yyyy"}
          />
        </Flex>
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.dateArea, {
            [classes.valid]: isClosingDateValid,
          })}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Data chiusura
          </Label>
          <DatePicker
            locale="it"
            selected={closingDate}
            onChange={(date) => onClosingDateChange(date)}
            wrapperClassName="datePicker"
            dateFormat={"dd/MM/yyyy"}
          />
        </Flex>
      </Grid>
    </Flex>
  );
}

export default Status;

/*

  onPreOpeningDateChange,
    <SelectableList
        title="Stato*"
        list={statuses}
        value={selectedStatus.name}
        onItemSelect={onStatusSelect}
        isEnabled={true}
        isMultiSelect={false}
        className={classes.list}
        headerClassName={classNames(classes.headerList, {
          [classes.valid]: isStatusValid,
        })}
        titleClassName={classes.titleList}
      />
      
      
      <Flex
        align="flex-start"
        direction="column"
        justify="flex-start"
        className={classNames(classes.dateArea, {
          [classes.valid]: isPreOpeningDateValid,
        })}
      >
        <Label tag="p" size="md" align="start" color="secondary">
          Data pre-apertura*
        </Label>
        <DatePicker
          selected={preOpeningDate}
          onChange={(date) => onPreOpeningDateChange(date)}
          wrapperClassName="datePicker"
        />
      </Flex>
      
        statuses,
  selectedStatus,
  onStatusSelect,
  isStatusValid,
  isPreOpeningDateValid,
  preOpeningDate,
      
      */
